"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var environment_1 = require("@shared/types/environment");
var partial_data_web_banner_html_1 = __importDefault(require("@components/partial-data/web/partial-data-web-banner.html"));
require("@components/alert-banner/pr-alert-banner.less");
(function (module) {
    'use strict';
    PartialDataWebBannerController.$inject = [
        '$filter',
        'rsEnvironment'
    ];
    function PartialDataWebBannerController($filter, env) {
        var $ctrl = this;
        var translate = $filter('translate');
        var bannerText = translate('DISPLAYING_PARTIAL_DATA_ALERT');
        var tooltipText = translate('PARTIAL_DATA_INFO');
        if (env.get(environment_1.ENV_VARS.IS_FIELDSET_PUBLISHING_V2_ENABLED)) {
            bannerText = translate('DISPLAYING_PREVIOUS_DATA');
            tooltipText = translate('PREVIOUS_DATA_INFO');
        }
        angular.extend($ctrl, {
            bannerText: bannerText,
            tooltipText: tooltipText,
            isPublic: function () {
                return $ctrl.bodyCtrl.isPublic;
            }
        });
    }
    module.component('prPartialDataWebBanner', {
        templateUrl: partial_data_web_banner_html_1.default,
        controller: PartialDataWebBannerController,
        require: {
            bodyCtrl: '^prBody'
        }
    });
}(angular.module('qualtrics.pr')));
